// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeout-modal {
  z-index: 1000;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.timeout-modal__body {
  width: 35rem;
  margin: 15rem auto;
  padding: 1rem;
  background-color: var(--ods-color-white);
}
.timeout-modal__body-header {
  color: var(--ods-color-purple-10) 0;
  font-size: 1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ep-timeout/ep-timeout.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,oCAAA;AAAF;AAEE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AAAJ;AAEI;EACE,mCAAA;EACA,kBAAA;AAAN","sourcesContent":["\n.timeout-modal {\n  z-index: 1000;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  &__body {\n    width: 35rem;\n    margin: 15rem auto;\n    padding: 1rem;\n    background-color: var(--ods-color-white);\n\n    &-header {\n      color: var(--ods-color-purple-10)0;\n      font-size: 1.25rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
